/*
	Odnośnik „ustawienia plików cookie” ma sens tylko wtedy, gdy na stronie faktycznie jest
	narzędzie zgód — tag klienta wklejany w panelu (Ustawienia ogólne → kod marketingowy
	w <head>, `config.marketingHead`), i tylko na prodzie. Bez niego kliknięcie w `#` nic nie
	robi, więc trzymamy taki odnośnik ukryty (`hidden` w szablonie) i odsłaniamy dopiero po
	wykryciu SDK.

	Tag ładuje się asynchronicznie i nie ma jednego wspólnego zdarzenia „gotowe” dla różnych
	narzędzi, więc odpytujemy globalne API kilka razy przez ~6 s i potem odpuszczamy.
	Samo otwarcie panelu robi już SDK: nasłuchuje kliknięć w `.ot-sdk-show-settings` (OneTrust)
	albo dostawia własny handler.
*/

const CONTAINERS = '[data-cookie-settings]';
const POLL_INTERVAL = 400;
const POLL_LIMIT = 15;

// Każde z narzędzi wystawia swój obiekt globalny — wystarczy dowolny z nich.
function consentSdkPresent() {
	return Boolean(window.OneTrust || window.Optanon || window.Cookiebot || window.CookieConsent);
}

function reveal() {
	document.querySelectorAll(CONTAINERS).forEach((element) => {
		element.hidden = false;
	});
}

function watch() {
	if (!document.querySelector(CONTAINERS)) {
		return;
	}

	let attempts = 0;

	const check = () => {
		if (consentSdkPresent()) {
			reveal();

			return;
		}

		if (++attempts < POLL_LIMIT) {
			window.setTimeout(check, POLL_INTERVAL);
		}
	};

	check();
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', watch);
} else {
	watch();
}
